export default __webpack_public_path__ + "static/media/292.278ce63c.jpg";